













































































































































































import User from '@/users/entities/user'
import { Component, Mixins, Prop, Vue, Ref } from 'vue-property-decorator'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import AddressInput from '@/locations/components/address-input/address-input.vue'

@Component
export default class UserDialog extends Mixins<EditDialogMixin<User>>(
  EditDialogMixin
) {
  model = new User()

  @Ref()
  private addressInput!: AddressInput

  private passwordConfirmation = ''
}
